import TablaConciliacion from "../../../TablaConciliacion";

function TablaDevisab() {
  return <TablaConciliacion nombreUseCase="DEVISAB" titulo="DEVISAB" />;
}

export default TablaDevisab;
